import { FC } from "react";

type Props = {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
};

const ShoppingBasket: FC<Props> = ({
  width = 37,
  height = 37,
  className,
  color = "#2A1645",
}) => {
  return (
    <svg
      className={className}
      viewBox="0 0 19 18"
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6775 7.16904C16.6247 7.1073 16.5592 7.05773 16.4854 7.02374C16.4116 6.98976 16.3313 6.97216 16.25 6.97217H12.875V4.72217C12.875 4.27462 12.6972 3.84539 12.3808 3.52893C12.0643 3.21246 11.6351 3.03467 11.1875 3.03467H7.81252C7.36497 3.03467 6.93575 3.21246 6.61928 3.52893C6.30281 3.84539 6.12502 4.27462 6.12502 4.72217V6.97217H2.75002C2.66849 6.97124 2.58772 6.98806 2.51333 7.02145C2.43894 7.05484 2.37269 7.104 2.31919 7.16553C2.26568 7.22706 2.22619 7.29949 2.20346 7.3778C2.18072 7.45611 2.17529 7.53842 2.18752 7.61904L3.24502 14.4534C3.2857 14.7217 3.42197 14.9662 3.6287 15.1419C3.83543 15.3176 4.09871 15.4127 4.37002 15.4097H14.6413C14.9126 15.4127 15.1759 15.3176 15.3826 15.1419C15.5893 14.9662 15.7256 14.7217 15.7663 14.4534L16.8125 7.61904C16.8238 7.53874 16.8176 7.45695 16.7943 7.37927C16.771 7.3016 16.7311 7.22989 16.6775 7.16904ZM7.25002 4.72217C7.25002 4.57298 7.30929 4.42991 7.41477 4.32442C7.52026 4.21893 7.66334 4.15967 7.81252 4.15967H11.1875C11.3367 4.15967 11.4798 4.21893 11.5853 4.32442C11.6908 4.42991 11.75 4.57298 11.75 4.72217V6.97217H7.25002V4.72217ZM14.6413 14.2847H4.35877L3.40815 8.09717H15.5919L14.6413 14.2847Z"
        fill={color}
      />
    </svg>
  );
};

export default ShoppingBasket;
